import { Link, useLocation } from "react-router-dom";
import { MessageCircle, Phone } from "lucide-react";
import { useSettings, track, waLink } from "@/lib/api";

export const WhatsAppFloat = () => {
  const { data: s } = useSettings();
  return (
    <a href={waLink(s)} target="_blank" rel="noopener noreferrer" data-testid="whatsapp-floating-btn" onClick={() => track("whatsapp_click", { placement: "floating" })}
      className="hidden md:flex fixed bottom-6 right-6 z-40 items-center gap-2 rounded-full bg-[#25D366] pl-3 pr-4 py-3 text-sm font-semibold text-[#062b16] shadow-lg shadow-black/40 transition-transform hover:-translate-y-0.5" aria-label="Talk to Admissions on WhatsApp">
      <MessageCircle size={20} /><span>Talk to Admissions</span>
    </a>
  );
};

export const StickyMobileCTA = () => {
  const { pathname } = useLocation();
  const { data: s } = useSettings();
  if (pathname.startsWith("/admin")) return null;
  const tel = `tel:${(s?.phone || "").replace(/\s/g, "")}`;
  return (
    <div data-testid="sticky-mobile-cta" className="md:hidden fixed bottom-0 inset-x-0 z-40 grid grid-cols-[48px_48px_1fr_1fr] gap-2 border-t border-white/10 bg-[#070C18]/95 backdrop-blur p-2 pb-[max(0.5rem,env(safe-area-inset-bottom))]">
      <a href={tel} data-testid="sticky-call-btn" aria-label="Call admissions" onClick={() => track("call_click", { placement: "sticky" })} className="grid place-items-center rounded-full border border-white/15 text-slate-100 active:bg-white/10"><Phone size={18} /></a>
      <a href={waLink(s)} target="_blank" rel="noopener noreferrer" data-testid="sticky-whatsapp-btn" aria-label="WhatsApp admissions" onClick={() => track("whatsapp_click", { placement: "sticky" })} className="grid place-items-center rounded-full bg-[#25D366] text-[#062b16]"><MessageCircle size={18} /></a>
      <Link to="/programs" data-testid="sticky-explore-programs" className="btn btn-outline !py-2.5 !px-3 text-xs">Programs</Link>
      <Link to="/book-counselling" data-testid="sticky-book-counselling" className="btn btn-primary !py-2.5 !px-3 text-xs" onClick={() => track("cta_click", { cta: "sticky_counselling" })}>Book Counselling</Link>
    </div>
  );
};
